import { ErrorBoundary, RollbarContext } from '@rollbar/react'
import * as actions from 'client/actions/actionsManagement'
import Page from 'client/components/core/Page/index'
import { WORK_AREA_ID } from 'client/constants/editorIds'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import useManagement, { selectors } from 'client/hooks/useManagement'
import { useActions } from 'common/hooks/useActions'
import React, {
  KeyboardEvent,
  MouseEvent,
  memo,
  useCallback,
  useRef,
} from 'react'
import { Trans } from 'react-i18next'
import { Overlay } from 'src/editor/layout/overlay'
import { twMerge } from 'tailwind-merge'

export const Content = memo(() => {
  const contentRef = useRef<HTMLElement | null>(null)
  const { isMobile } = useDeviceModeContext()
  const isSomethingEditing = useManagement(selectors.isSomethingEditing)
  const toggleSettings = useActions(actions.toggleSettings)

  const disableMobileSettings = useCallback(
    (e: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => {
      if ('key' in e) {
        if (e.key !== 'Enter' && e.key !== ' ') {
          return
        }
      }

      if (isMobile && isSomethingEditing && contentRef.current === e.target) {
        toggleSettings(null)
      }
    },
    [isMobile, isSomethingEditing, toggleSettings],
  )

  return (
    <RollbarContext context="editor">
      <ErrorBoundary
        fallbackUI={() => (
          <Trans parent="h3">core.errors.went_wrong_contact_support</Trans>
        )}
      >
        <main
          className="relative flex h-full items-center justify-center"
          onClick={disableMobileSettings}
          onKeyUp={disableMobileSettings}
          ref={contentRef}
        >
          <div
            className={twMerge(
              isMobile ? 'block' : 'contents',
              'transform-[translate(-50%)] absolute top-[20px] left-1/2 h-[660px] w-[375px]',
              'border-[#23282d] border-[10px] border-t-[30px] border-b-[50px]',
              'rounded-[20px]',
            )}
          >
            <div
              id={WORK_AREA_ID}
              className={twMerge(
                isMobile
                  ? 'h-[580px] w-[355px] scroll-smooth'
                  : 'relative flex w-full flex-col overflow-hidden',
              )}
              style={
                !isMobile
                  ? { height: 'calc(100vh - var(--layout-header-height))' }
                  : undefined
              }
            >
              <Page />
              <Overlay />
            </div>
          </div>
        </main>
      </ErrorBoundary>
    </RollbarContext>
  )
})
